export default __webpack_public_path__ + "static/media/quantumChip.b53a0948.png";